angular.module('qkr').directive('toggleSwitch', () => ({
    restrict: 'E',
    template: require('../../directives/forms/toggle_switch.html'),
    require: ['ngModel'],
    scope: {
        id: '=',
        label: '=',
        ngModel: '=',
        ngChange: '&',
        ngClick: '&',
        ngDisabled: '='
    }
}));



// WEBPACK FOOTER //
// ./src/directives/forms/toggle_switch.js